import React, { useState, useEffect, useContext } from 'react';
import md5 from 'md5';
import dayjs from 'dayjs';

import { PostComment } from 'src/components/Comments/PostComment/PostComment';
import { Avatar, Button, Typography } from '@riac/design-system';

import { LoginContext } from 'src/lib/LoginContext';
import { AccountContext } from 'src/lib/AccountContext';

import { ICommentProps } from 'src/components/Comments/Comment/Comment.i';
import { IconReply } from '@riac/design-system';


//DayJS Note: Times are stored in UTC and formatted to local time.
export const Comment = ({ post, comment, account, status }: ICommentProps) => {
  const { isLoggedIn } = useContext(LoginContext);
  const { getAdmin, isAdmin } = useContext(AccountContext);
  const [toggle, setToggle] = useState(false);
  const [pending, setPending] = useState([]);

  const getReplies = async () => {
    if(isLoggedIn) {
      const status = isAdmin ? 'Admin' : 'Pending';
      const commentId = comment ? comment.ID : '';
      const additionalReq = await fetch(`/api/ghost/getBlogReply${status}/${post.id}/${commentId}`, { credentials: 'include' });
      const additional = isLoggedIn ? await additionalReq.json() : [];
      setPending(isLoggedIn ? additional : []);
    }
  };

  useEffect(() => {
    getAdmin();
    getReplies();
  }, []);


  return (
    <div className='bg-surface-dark p-6 flex flex-col gap-2'>
      <div className='flex flex-col gap-2'>
        {status && <Typography size='sm'>This comment is waiting for approval.</Typography>}
        <div className='flex flex-row gap-3'>
          <Avatar
            src={`https://www.gravatar.com/avatar/${md5(comment.Email || '')}?r=g&d=mp`}
          />
          <div>
            <Typography weight='bold'>{comment.Nickname ? comment.Nickname : `${comment.FirstName} ${comment.LastName}`}</Typography>
            <Typography size='sm'>{dayjs(comment.PostDate).format('LL')}</Typography>
          </div>
        </div>
      </div>
      <Typography>{comment.Comments}</Typography>
      <div className='flex flex-col gap-4'>
        {(comment.Reply && comment.Reply.length > 0) && comment.Reply.map((reply) => (
          <div key={reply.ID} className='flex flex-col gap-2'>
            <div className='flex flex-row gap-5'>
              <Avatar
                src={`https://www.gravatar.com/avatar/${md5(reply.Email || '')}?r=g&d=mp`}
              />
              <div>
                <Typography weight='bold'>{reply.Nickname ? reply.Nickname : `${reply.FirstName} ${reply.LastName}`}</Typography>
                <Typography size='sm'>{dayjs(reply.PostDate).format('LL')}</Typography>
              </div>
            </div>
            <Typography>{reply.Comments}</Typography>
          </div>
        ))}
        {pending.length > 0 && pending.map((reply) => (
          <div className='flex flex-col gap-2' key={reply.ID}>
            <Typography size='sm'>This comment is waiting for approval.</Typography>
            <div className='flex flex-row gap-5'>
              <Avatar
                src={`https://www.gravatar.com/avatar/${md5(reply.Email || '')}?r=g&d=mp`}
              />
              <div>
                <Typography weight='bold'>{reply.Nickname ? reply.Nickname : `${reply.FirstName} ${reply.LastName}`}</Typography>
                <Typography size='sm' >{dayjs(reply.PostDate).format('LL')}</Typography>
              </div>
            </div>
            <Typography>{reply.Comments}</Typography>
          </div>
        ))}
        {!status
          && <div className='flex flex-row justify-end w-full'>
            <Button size='sm' variant='secondary' onPress={() => setToggle(!toggle)} icon={<IconReply className='w-5 h-5'/>} className='flex flex-row items-center gap-1'>
               Reply
            </Button>
          </div>
        }
        {toggle
          && <React.Fragment>
            {isLoggedIn
              && <PostComment
                post={post}
                update={() => getReplies()}
                commentId={comment.ID}
                account={account}
                handleCancel={() => setToggle(false)}
              />
            }
            {!isLoggedIn && <p>Please <Button variant='link' className='p-0' to='/login'>login</Button> to reply.</p>}
          </React.Fragment>
        }
      </div>
    </div>
  );
};
